import { render, staticRenderFns } from "./ProjectAttachments.vue?vue&type=template&id=470a6f49&scoped=true&"
import script from "./ProjectAttachments.vue?vue&type=script&lang=js&"
export * from "./ProjectAttachments.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAttachments.vue?vue&type=style&index=0&id=470a6f49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a6f49",
  null
  
)

export default component.exports